

import React from "react";
import {
    List,
    Datagrid,
    TextField,
    EditButton,
    Create,
    Edit,
    SimpleForm,
    TextInput,
    required,
} from "react-admin";


export const OrganizationList = () => (
    <List>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="name" label="Название" />
            <TextField source="bin" label="БИН" />
            <EditButton />
        </Datagrid>
    </List>
);


export const OrganizationCreate = () => (
    <Create>
        <SimpleForm>
            <TextInput source="name" label="Название" validate={[required()]} />
            <TextInput source="bin" label="БИН" validate={[required()]} />
        </SimpleForm>
    </Create>
);


export const OrganizationEdit = () => (
    <Edit>
        <SimpleForm>
            <TextInput source="name" label="Название" validate={[required()]} />
            <TextInput source="bin" label="БИН" validate={[required()]} />
        </SimpleForm>
    </Edit>
);